<template>
  <b-row>
    <b-col cols="12" md="6">
      <b-card class="title card-custom gutter-b" no-body>
        <b-card-body class="d-flex flex-column">
          <div
            class="d-flex justify-content-between align-items-center flex-grow-1"
          >
            <h3 class="font-weight-bolder mb-0">{{ project.title }}</h3>
            <div v-if="hasInstance(project)">
              <div
                class="d-flex justify-content-center align-items-center"
                v-if="isFinished(project._id)"
              >
                <div class="text-right">
                  <div class="d-flex ml-0 my-1 justify-content-end">
                    <div>
                      <i v-if="stars(project) >= 1" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 2" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 3" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 4" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 5" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                  </div>
                </div>
                <div
                  class="text-right text-muted pl-2"
                  v-for="po in project.points"
                  :key="po._id"
                >
                  <span v-if="stars(project) == 1"
                    >{{ po.points * 0.1 }} points</span
                  >
                  <span v-else-if="stars(project) == 2"
                    >{{ po.points * 0.3 }} points</span
                  >
                  <span v-else-if="stars(project) == 3"
                    >{{ po.points * 0.5 }} points</span
                  >
                  <span v-else-if="stars(project) == 4"
                    >{{ po.points * 0.7 }} points</span
                  >
                  <span v-else-if="stars(project) == 5"
                    >{{ po.points }} points</span
                  >
                </div>
              </div>
              <div
                class="btn btn-primary font-weight-bolder px-7 mr-5"
                :class="
                  hasInstance(project).dateFinished ? 'btn-info' : 'btn-warning'
                "
                v-if="!hasInstance(project).instances"
              >
                {{ hasInstance(project).dateFinished ? "Finished" : "Live" }}
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
      <b-card
        class="image"
        no-body
        :style="
          project.image
            ? 'background-image:url(https://api.xupxup.net/' + project.image
            : 'background-image:url(/media/error/bg6.jpg)'
        "
      ></b-card>
      <b-card class="card-custom gutter-b description" no-body>
        <b-card-body class="d-flex flex-column">
          <div class="justify-content-between flex-grow-1">
            <h3 class="font-weight-bolder mb-2">Description</h3>
            <p v-html="project.description"></p>
          </div>
        </b-card-body>
      </b-card>
      <b-card
        class=" card-custom gutter-b"
        no-body
        v-if="project.sections.length < 1"
      >
        <b-card-body>
          <h2 class="text-dark mb-8">Criteria</h2>
          <p v-html="project.criteria"></p>
          <div v-if="project.url">
            <h2 class="text-dark mb-8">
              <a :href="project.url">Website</a>
            </h2>
          </div>
        </b-card-body>
      </b-card>

      <div
        v-if="project.sections.length < 1 && !isOpen(project)"
        class="botoStartSingle"
      >
        <div
          class="btn btn-block btn-primary font-weight-bolder py-4 mb-5"
          v-on:click="
            createInstanceProject(
              project._id,
              project.numberOfUsers,
              currentUser._id
            )
          "
        >
          Start project
        </div>
      </div>
    </b-col>
    <b-col cols="12" md="6">
      <b-card class="card-custom gutter-b mt-0" no-body>
        <b-card-body class="pt-4">
          <div v-if="project.tags.length > 0">
            <TagsPills
              :tagId="t"
              v-for="t in project.tags"
              :key="t._id"
              class="mt-5"
            />
          </div>
          <ProfilesBar :project="project"></ProfilesBar>

          <div class="mb-0">
            <div class="d-flex align-items-center pt-7">
              <div class="symbol symbol-45 symbol-dark mr-4">
                <span class="symbol-label p-6">
                  <span class=" text-white">
                    <b-icon-award-fill></b-icon-award-fill>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >Level</span
                >
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                v-if="project.level"
                >{{
                  this.levels.find((lvl) => lvl._id == project.level).name
                }}</span
              >
            </div>
            <div
              class="d-flex align-items-center pt-7"
              v-if="project.estimatedTime"
            >
              <div class="symbol symbol-45 symbol-dark mr-4">
                <span class="symbol-label p-6">
                  <span class="bg-dark text-white">
                    <b-icon-clock-fill></b-icon-clock-fill>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >Time</span
                >
                <span class="text-muted font-weight-bold">Estimated</span>
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                >{{ project.estimatedTime }} h</span
              >
            </div>
            <div
              class="d-flex align-items-center pt-7"
              v-if="project.sections.length == 0"
            >
              <div class="symbol symbol-45 symbol-dark mr-4 ">
                <span class="symbol-label ">
                  <span class="">
                    <b-icon-person-fill></b-icon-person-fill>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >Tipology</span
                >
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                v-if="project.numberOfUsers == 1"
              >
                <i class="fas fa-user"></i>
              </span>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                v-else
              >
                <i class="fas fa-users"></i>
              </span>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <div v-if="sections.length > 0">
        <b-card
          class="card-custom gutter-b example example-compact"
          no-body
          v-for="(s, index) in sections"
          :key="s._id"
        >
          <b-card-header>
            <div class="card-title">
              <h3 class="card-label font-weight-boldest">
                {{ s.title }}
              </h3>
              <div
                class="d-flex justify-content-center align-items-center"
                v-if="isFinished(s._id)"
              >
                <div class="text-right">
                  <div class="d-flex ml-0 my-1 justify-content-end">
                    <div>
                      <i v-if="stars(s) >= 1" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(s) >= 2" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(s) >= 3" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(s) >= 4" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(s) >= 5" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                  </div>
                </div>
                <div
                  class="text-right text-muted pl-2"
                  v-for="po in s.points"
                  :key="po._id"
                >
                  <span v-if="stars(s) == 1">{{ po.points * 0.1 }} points</span>
                  <span v-else-if="stars(s) == 2"
                    >{{ po.points * 0.3 }} points</span
                  >
                  <span v-else-if="stars(s) == 3"
                    >{{ po.points * 0.5 }} points</span
                  >
                  <span v-else-if="stars(s) == 4"
                    >{{ po.points * 0.7 }} points</span
                  >
                  <span v-else-if="stars(s) == 5">{{ po.points }} points</span>
                </div>
              </div>
            </div>
            <div class="card-toolbar">
              <div
                class="btn btn-primary font-weight-bolder px-7 mr-5"
                v-if="
                  !hasInstance(s) && isLastInstanceClosed(project, s, index)
                "
                v-on:click="
                  createInstance(
                    project._id,
                    s.numberOfUsers,
                    s._id,
                    currentUser._id
                  )
                "
              >
                Start project
              </div>

              <div
                class="btn btn-primary font-weight-bolder px-7 mr-5"
                :class="isFinished(s._id) ? 'btn-info' : 'btn-warning'"
                v-if="isFinished(s._id)"
              >
                {{ isFinished(s._id) ? "Finished" : "Live" }}
              </div>

              <b-button v-b-toggle="'collapse-' + index">
                <i class="fas fa-angle-down"></i>
              </b-button>
            </div>
          </b-card-header>
          <b-collapse
            :visible="!isVisible(s, project)"
            v-bind:id="'collapse-' + index"
            class="mt-2"
          >
            <b-card-body v-if="isLastInstanceClosed(project, s, index)">
              <img
                :src="'https://api.xupxup.net/' + s.image"
                v-if="s.image"
                class="w-100"
              />
              <img
                :src="
                  '/media/error/bg' +
                    (Math.round(Math.random() * 3) + 2) +
                    '.jpg'
                "
                v-else
                class="w-100"
              />
              <h3 class="font-weight-bolder" v-if="s.description">
                Description
              </h3>
              <p
                class="card-text"
                v-if="s.description"
                v-html="s.description"
              ></p>
              <h3 class="font-weight-bolder mt-10" v-if="s.criteria">
                Criteria
              </h3>
              <p class="card-text" v-if="s.criteria" v-html="s.criteria"></p>
              <div v-if="s.url">
                <h6 class="text-dark mb-8">
                  <a :href="s.url" target="_blank">Reference Link</a>
                </h6>
              </div>
              <div class="row">
                <div class="col-6 col-md-2" v-if="s.startDate">
                  <span class="d-block font-weight-bold mb-4">Start Date</span>
                  <span
                    class="btn btn-light-primary btn-sm font-weight-bold btn-upper btn-text"
                    >{{ s.startDate | moment("D MMM YYYY") }}</span
                  >
                </div>

                <div class="col-6 col-md-2" v-if="s.endDate">
                  <span class="d-block font-weight-bold mb-4">End Date</span>
                  <span
                    class="btn btn-light-primary btn-sm font-weight-bold btn-upper btn-text"
                    >{{ s.endDate | moment("D MMM YYYY") }}</span
                  >
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col" v-if="s.estimatedTime">
                  <span class="d-block font-weight-bold mb-4">
                    Estimated Time</span
                  >
                  <span class="btn btn-sm font-weight-bold bg-dark text-white">
                    <b-icon-clock-fill class="mr-2"></b-icon-clock-fill>
                    {{ s.estimatedTime }} h
                  </span>
                </div>
                <div class="col text-center" v-if="s.numberOfUsers">
                  <span class="d-block font-weight-bold mb-4">Tipology</span>
                  <span
                    class="label label-lg font-weight-bold bg-dark text-white"
                  >
                    <b-icon-people-fill
                      v-if="s.numberOfUsers > 1"
                    ></b-icon-people-fill>
                    <b-icon-person-fill v-else></b-icon-person-fill>
                  </span>
                </div>
                <div
                  class="col text-right"
                  v-for="po in s.points"
                  :key="po._id"
                >
                  <span class="d-block font-weight-bold mb-4">Points</span>
                  <span class=" font-weight-bold btn-upper btn-text"
                    >{{ po.points }} points</span
                  >
                </div>
              </div>
            </b-card-body>
            <b-card-body v-else>
              <span class="text-muted"
                >Sorry... You must close the previous section in order to
                continue...</span
              >
            </b-card-body>

            <b-card-footer v-if="isOpen(s)">
              <div class="proof ">
                <div class="versions" v-if="hasInstance(s).proof">
                  <h4 class="text-dark font-weight-bolder ">
                    Uploaded Versions
                  </h4>
                  <b-list-group class="mb-5 ">
                    <b-list-group-item
                      v-for="(v, index) in hasInstance(s).proof"
                      :key="v._id"
                    >
                      <div class=" d-grid  align-items-center">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-h4"
                        >
                          v{{ index + 1 }}
                        </span>

                        <div v-if="v.images">
                          <a
                            class="btn btn-secondary btn-sm mr-2"
                            :href="'https://api.xupxup.net/' + image"
                            target="_blank"
                            v-for="(image, i) in v.images"
                            :key="i"
                          >
                            Imatge {{ i + 1 }}
                          </a>
                        </div>
                        <div class="stars ">
                          <div v-if="v.isChecked">
                            <span
                              ><b-icon-star></b-icon-star> {{ v.stars }}</span
                            >
                          </div>
                          <div v-else>
                            <span class="ml-3">
                              <i
                                class="fa fa-star mr-1 text-light-secondary font-size-lg"
                              ></i>
                              <span
                                class=" font-weight-bolder text-light-secondary"
                                >0</span
                              >
                            </span>
                          </div>
                        </div>
                        <div class="text-right">
                          <b-button-group>
                            <b-button
                              :href="v.url"
                              variant="outline-success"
                              size="sm"
                              :disabled="!v.url"
                            >
                              <b-icon-link></b-icon-link>
                            </b-button>
                            <b-button
                              :href="v.url"
                              variant="outline-info"
                              size="sm"
                              :disabled="!v.url"
                            >
                              <span v-if="v.isChecked">
                                <b-icon-lock></b-icon-lock>
                              </span>
                              <span v-else>
                                <b-icon-unlock></b-icon-unlock>
                              </span>
                            </b-button>
                            <b-button
                              v-if="v.comments"
                              :variant="
                                v.comments.length
                                  ? 'warning'
                                  : 'outline-warning'
                              "
                              size="sm"
                              v-b-toggle="'comment-' + v._id"
                            >
                              <span v-if="v.comments.length">
                                <b-icon-chat-dots></b-icon-chat-dots>
                              </span>
                              <span v-else>
                                <b-icon-chat></b-icon-chat>
                              </span>
                            </b-button>
                            <b-button
                              variant="danger"
                              size="sm"
                              :disabled="v.isChecked"
                              @click="deleteVersion(hasInstance(s), v)"
                            >
                              <b-icon-x></b-icon-x>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                      <b-collapse :id="'comment-' + v._id">
                        <div class="comments">
                          <comments-box
                            :instance="hasInstance(s)"
                            :version="v"
                          ></comments-box>
                        </div>
                      </b-collapse>
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <div class="uploadVersion">
                  <h4 class="text-dark font-weight-bolder ">
                    Did you finished? Upload Project
                  </h4>
                  <div class="my-5 todeliver">
                    <p v-html="s.proof.toDeliver"></p>
                  </div>
                  <div v-if="hasChecked(s)">
                    <div class="url my-5" v-if="s.proof.url">
                      <b-form-group
                        description="Please, use full Google Drive URL"
                      >
                        <b-form-input
                          v-model="urlToUpload"
                          placeholder="Enter the url of this project"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="upload" v-if="s.proof.images > 0">
                      <VueFileAgent
                        ref="vueFileAgent"
                        :theme="'list'"
                        :multiple="true"
                        :deletable="true"
                        :meta="true"
                        :accept="'image/*,.zip'"
                        :maxSize="'10MB'"
                        :maxFiles="2"
                        :helpText="'Choose images'"
                        :errorText="{
                          type: 'Invalid file type. Only images Allowed',
                          size: 'Files should not exceed 10MB in size',
                        }"
                        @select="filesSelected($event)"
                        @beforedelete="onBeforeDelete($event)"
                        @delete="fileDeleted($event)"
                        v-model="fileRecords"
                      ></VueFileAgent>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div>
                        <b-badge variant="secondary" class="mt-4">
                          Uploading {{ fileRecordsForUpload.length }} files
                        </b-badge>
                      </div>

                      <span
                        class="btn bg-success mt-5 text-white"
                        @click="uploadFiles(project, s)"
                      >
                        Send Version
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    You can not upload a new version now! wait for a previous
                    version assessment
                  </div>
                  <div
                    class="closingSection bg-dark text-white p-5 mt-5 d-flex justify-content-between"
                    v-if="hasInstance(s).proof.length > 0"
                  >
                    <div>
                      <h4 class="m-0">Do you want to close this section?</h4>
                      <span class="text-muted">
                        Caution!! When you close a section, you can not reopen
                        to get more stars
                      </span>
                    </div>
                    <b-button
                      variant="outline-danger"
                      @click="closeProject(hasInstance(s))"
                    >
                      Close Project
                    </b-button>
                  </div>
                </div>
              </div>
            </b-card-footer>
          </b-collapse>
        </b-card>
      </div>
      <div v-else>
        <b-card class="card-custom gutter-b example example-compact" no-body>
          <b-card-header>
            <div class="card-title">
              <h3 class="card-label font-weight-boldest">
                {{ project.title }}
              </h3>
              <div
                class="d-flex justify-content-center align-items-center"
                v-if="isFinished(project._id)"
              >
                <div class="text-right">
                  <div class="d-flex ml-0 my-1 justify-content-end">
                    <div>
                      <i v-if="stars(project) >= 1" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 2" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 3" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 4" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                    <div>
                      <i v-if="stars(project) >= 5" class="fas fa-star"></i>
                      <i v-else class="far fa-star"></i>
                    </div>
                  </div>
                </div>
                <div
                  class="text-right text-muted pl-2"
                  v-for="po in project.points"
                  :key="po._id"
                >
                  <span v-if="stars(project) == 1"
                    >{{ po.points * 0.1 }} points</span
                  >
                  <span v-else-if="stars(project) == 2"
                    >{{ po.points * 0.3 }} points</span
                  >
                  <span v-else-if="stars(project) == 3"
                    >{{ po.points * 0.5 }} points</span
                  >
                  <span v-else-if="stars(project) == 4"
                    >{{ po.points * 0.7 }} points</span
                  >
                  <span v-else-if="stars(project) == 5"
                    >{{ po.points }} points</span
                  >
                </div>
              </div>
            </div>
            <div class="card-toolbar">
              <!-- <div
                class="btn btn-primary font-weight-bolder px-7 mr-5"
                v-if="!hasInstance(project)"
              >
                Start project
              </div> -->

              <div
                class="btn btn-primary font-weight-bolder px-7 mr-5"
                :class="isFinished(project._id) ? 'btn-info' : 'btn-warning'"
                v-if="isFinished(project._id)"
              >
                {{ isFinished(project._id) ? "Finished" : "Live" }}
              </div>
            </div>
          </b-card-header>

          <b-card-footer v-if="isOpen(project)">
            <div class="proof ">
              <div class="versions" v-if="hasInstance(project).proof">
                <h4 class="text-dark font-weight-bolder ">
                  Uploaded Versions
                </h4>
                <b-list-group class="mb-5 ">
                  <b-list-group-item
                    v-for="(v, index) in hasInstance(project).proof"
                    :key="v._id"
                  >
                    <div class=" d-grid  align-items-center">
                      <span
                        class="text-dark-75 font-weight-bolder font-size-h4"
                      >
                        v{{ index + 1 }}
                      </span>

                      <div v-if="v.images">
                        <a
                          class="btn btn-secondary btn-sm mr-2"
                          :href="'https://api.xupxup.net/' + image"
                          target="_blank"
                          v-for="(image, i) in v.images"
                          :key="i"
                        >
                          Imatge {{ i + 1 }}
                        </a>
                      </div>
                      <div class="stars ">
                        <div v-if="v.isChecked">
                          <span><b-icon-star></b-icon-star> {{ v.stars }}</span>
                        </div>
                        <div v-else>
                          <span class="ml-3">
                            <i
                              class="fa fa-star mr-1 text-light-secondary font-size-lg"
                            ></i>
                            <span
                              class=" font-weight-bolder text-light-secondary"
                              >0</span
                            >
                          </span>
                        </div>
                      </div>
                      <div class="text-right">
                        <b-button-group>
                          <b-button
                            :href="v.url"
                            variant="outline-success"
                            size="sm"
                            :disabled="!v.url"
                          >
                            <b-icon-link></b-icon-link>
                          </b-button>
                          <b-button
                            :href="v.url"
                            variant="outline-info"
                            size="sm"
                            :disabled="!v.url"
                          >
                            <span v-if="v.isChecked">
                              <b-icon-lock></b-icon-lock>
                            </span>
                            <span v-else>
                              <b-icon-unlock></b-icon-unlock>
                            </span>
                          </b-button>
                          <b-button
                            v-if="v.comments"
                            :variant="
                              v.comments.length ? 'warning' : 'outline-warning'
                            "
                            size="sm"
                            v-b-toggle="'comment-' + v._id"
                          >
                            <span v-if="v.comments.length">
                              <b-icon-chat-dots></b-icon-chat-dots>
                            </span>
                            <span v-else>
                              <b-icon-chat></b-icon-chat>
                            </span>
                          </b-button>
                          <b-button
                            variant="danger"
                            size="sm"
                            :disabled="v.isChecked"
                            @click="deleteVersion(hasInstance(project), v)"
                          >
                            <b-icon-x></b-icon-x>
                          </b-button>
                        </b-button-group>
                      </div>
                    </div>
                    <b-collapse :id="'comment-' + v._id">
                      <div class="comments">
                        <comments-box
                          :instance="hasInstance(project)"
                          :version="v"
                        ></comments-box>
                      </div>
                    </b-collapse>
                  </b-list-group-item>
                </b-list-group>
              </div>
              <div class="uploadVersion">
                <h4 class="text-dark font-weight-bolder ">
                  Did you finished? Upload Project
                </h4>
                <div class="my-5 todeliver">
                  <p v-html="project.proof.toDeliver"></p>
                </div>
                <div v-if="hasChecked(project)">
                  <div class="url my-5" v-if="project.proof.url">
                    <b-form-group
                      description="Please, use full Google Drive URL"
                    >
                      <b-form-input
                        v-model="urlToUpload"
                        placeholder="Enter the url of this project"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="upload" v-if="project.proof.images > 0">
                    <VueFileAgent
                      ref="vueFileAgent"
                      :theme="'list'"
                      :multiple="true"
                      :deletable="true"
                      :meta="true"
                      :accept="'image/*,.zip'"
                      :maxSize="'10MB'"
                      :maxFiles="2"
                      :helpText="'Choose images'"
                      :errorText="{
                        type: 'Invalid file type. Only images Allowed',
                        size: 'Files should not exceed 10MB in size',
                      }"
                      @select="filesSelected($event)"
                      @beforedelete="onBeforeDelete($event)"
                      @delete="fileDeleted($event)"
                      v-model="fileRecords"
                    ></VueFileAgent>
                  </div>
                  <div class="d-flex justify-content-between">
                    <div>
                      <b-badge variant="secondary" class="mt-4">
                        Uploading {{ fileRecordsForUpload.length }} files
                      </b-badge>
                    </div>

                    <span
                      class="btn bg-success mt-5 text-white"
                      @click="uploadFiles(project, project)"
                    >
                      Send Version
                    </span>
                  </div>
                </div>
                <div v-else>
                  You can not upload a new version now! wait for a previous
                  version assessment
                </div>
                <div
                  class="closingSection bg-dark text-white p-5 mt-5 d-flex justify-content-between"
                  v-if="hasInstance(project).proof.length > 0"
                >
                  <div>
                    <h4 class="m-0">Do you want to close this section?</h4>
                    <span class="text-muted">
                      Caution!! When you close a section, you can not reopen to
                      get more stars
                    </span>
                  </div>
                  <b-button
                    variant="outline-danger"
                    @click="closeProject(hasInstance(project))"
                  >
                    Close Project
                  </b-button>
                </div>
              </div>
            </div>
          </b-card-footer>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import { mapGetters } from "vuex";
import TagsPills from "@/view/layout/dashboard/TagsPills";
import ProfilesBar from "@/view/layout/dashboard/ProfilesBar";
import Swal from "sweetalert2";
import CommentsBox from "../layout/extras/CommentsBox.vue";

export default {
  name: "project-single",
  components: { TagsPills, ProfilesBar, CommentsBox },
  data() {
    return {
      hover: false,
      //insta: { project: "", users: [], instances: [] },
      instasection: { project: "", users: [] },
      instasectiongrup: { project: "", team: "", users: [] },
      instancia: [],
      team: [],
      urlToUpload: "",
      fileRecords: [],
      uploadUrl: process.env.VUE_APP_API_URL + "upload",
      uploadHeaders: { "X-Test-Header": "vue-file-agent" },
      fileRecordsForUpload: [], // maintain an upload queue
    };
  },
  created() {
    //id = this.$route.params.projectId;

    console.log(this.currentUser);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Project" }]);
  },
  methods: {
    hasChecked(s) {
      let lastVersion = this.hasInstance(s).proof[
        this.hasInstance(s).proof.length - 1
      ];
      if (lastVersion) {
        return lastVersion.isChecked;
      } else {
        return true;
      }
    },
    isLastInstanceClosed(p, s, i) {
      if (i > 0) {
        console.log("project", p);
        console.log("my Instances", this.myInstances);
        const id = this.sections[i - 1]._id;
        console.log(
          id,
          this.myInstances.find((i) => i.project == id)
        );
        if (this.myInstances.find((i) => i.project == id)) {
          return this.myInstances.find((i) => i.project == id).dateFinished;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    hasInstance(s) {
      return this.myInstances.find((i) => i.project == s._id);
    },
    isOpen(s) {
      return this.myInstances.find(
        (i) => i.project == s._id && !i.dateFinished
      );
    },
    isFinished(id) {
      return this.myInstances.find((i) => i.project == id && i.dateFinished);
    },
    stars(s) {
      return this.myInstances.find((i) => i.project == s._id).stars;
    },
    isVisible(s, project) {
      let mi = this.myInstances.find((i) => i.project == s._id);
      if (mi) {
        return mi.dateFinished;
      } else {
        console.log(project.sections);
        let sect = project.sections.filter(
          (s) => !this.myInstances.find((m) => m.project == s._id)
        );
        console.log(
          "sect",
          this.myInstances.find((m) => m.project == s._id)
        );
        console.log("sect", sect);
        return sect[0]._id != s._id;
      }
      //return this.myInstances.find(i=> i.project==s._id)
    },
    createInstance: function(project, numofusers, section, user) {
      if (numofusers === 1) {
        console.log("Creating individual project (section)", user);
        let instance = this.myInstances.find((i) => i.project == project);

        let instanceSection = {
          project: section,
          users: user,
        };

        axios.post("instances", instanceSection).then((response) => {
          console.log("saved instance section", response);
          if (instance) {
            instance.instances.push(response.data._id);
            if (response.status == 201) {
              axios
                .put("instances/" + instance._id, instance)
                .then((responses) => {
                  console.log("updated project instance", responses);
                  this.$store.dispatch("fetchMyInstances");
                  //this.$router.push({ name: "projects" });
                });
            }
          } else {
            instance = {
              instances: [response.data._id],
              project: project,
              users: [user],
            };
            if (response.status == 201) {
              axios.post("instances/", instance).then((responses) => {
                console.log("Created project instance", responses);
                this.$store.dispatch("fetchMyInstances");
                //this.$router.push({ name: "projects" });
              });
            }
          }
        });
      } else {
        console.log("Creating group project (section)");

        console.log("My Team", this.myTeam);

        let instanceGroup = this.myInstances.find((i) => i.project == project);

        let instanceSectionGroup = {
          project: section,
          team: this.myTeam._id,
          users: this.myTeam.users,
        };

        if (instanceSectionGroup.users.length > 0) {
          axios.post("instances", instanceSectionGroup).then((response) => {
            console.log("saved instace section", response);
            if (instanceGroup) {
              instanceGroup.instances.push(response.data._id);
              if (response.status == 201) {
                axios
                  .put("instances/" + instanceGroup._id, instanceGroup)
                  .then((responses) => {
                    this.$store.dispatch("fetchMyInstances");
                    console.log("updated project instance", responses);
                    //this.$router.push({ name: "projects" });
                  });
              }
            } else {
              instanceGroup = {
                instances: [response.data._id],
                project: project,
                team: this.myTeam._id,
                users: this.myTeam.users,
              };

              if (response.status == 201) {
                axios.post("instances/", instanceGroup).then((responses) => {
                  console.log("Created project instance", responses);
                  this.$store.dispatch("fetchMyInstances");
                  //this.$router.push({ name: "projects" });
                });
              }
            }
          });

          this.instagrup = [];
        } else {
          console.log("ERROR: instancia no creada");
        }
      }
    },

    createInstanceProject: function(project, numofusers, user) {
      console.log("Creating individual project (parent)");

      if (numofusers === 1) {
        let insta = { project: project, users: [user], instances: [] };

        console.log("insta", insta);
        axios.post("instances", insta).then((response) => {
          console.log("saved project", response);
          console.log(response.status);
          if (response.status == 201) {
            console.log("creada");
            this.$store.dispatch("fetchMyInstances");
            //this.$router.push({ name: "projects" });
          }
        });
      } else {
        console.log("Creating group project (parent)");

        console.log("My Team", this.myTeam);

        var instagrup = {
          project: project,
          team: user.team,
          users: this.myTeam.users,
          instances: [],
        };

        //console.log("instagrup", instagrup);
        if (instagrup.users.length > 0) {
          axios.post("instances", instagrup).then((response) => {
            //console.log("saved project", response);
            //console.log(response.status);
            if (response.status == 201) {
              console.log("creada");
              this.$store.dispatch("fetchMyInstances");
              this.$router.push({ name: "projects" });
            }
          });
        } else {
          console.log("ERROR: instancia no creada");
        }
      }
    },
    uploadFiles: async function(p, s) {
      console.log(p, s);
      let proof = {};
      if (s.proof.images > 0) {
        this.uploadHeaders.folder =
          "instances/" + p._id + "/" + (s != p ? s._id + "/" : "");
        console.log(this.uploadHeaders.folder);
        // Using the default uploader. You may use another uploader instead.
        console.log(this.$refs.vueFileAgent);
        if (Array.isArray(this.$refs.vueFileAgent)) {
          await this.$refs.vueFileAgent[0].upload(
            this.uploadUrl,
            this.uploadHeaders,
            this.fileRecordsForUpload
          );
        } else {
          await this.$refs.vueFileAgent.upload(
            this.uploadUrl,
            this.uploadHeaders,
            this.fileRecordsForUpload
          );
        }
        proof.images = [];
        this.fileRecords.forEach((f) => {
          console.log(f);
          proof.images.push(f.upload.data.file.path);
        });
      }
      if (s.proof.url) {
        proof.url = this.urlToUpload;
      }
      this.hasInstance(s).proof.push(proof);
      axios
        .put(
          "instances/" +
            (s != p ? this.hasInstance(s)._id : this.hasInstance(p)._id),
          this.hasInstance(s)
        )
        .then((response) => {
          console.log(response);
          this.$store.dispatch("fetchMyInstances");
          if (response.status == 200) {
            Swal.fire({
              title: "Update profile",
              text: "",
              icon: "success",
            });
          }
        });
      this.fileRecordsForUpload = [];
      this.urlToUpload = "";
    },
    deleteUploadedFile: function(fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      );
    },
    filesSelected: function(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      );
    },
    onBeforeDelete: function(fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function(fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
    deleteVersion(i) {
      i.proof.pop();
      axios.put("instances/" + i._id, i).then(() => {
        this.$store.dispatch("fetchMyInstances");
      });
    },
    closeProject(i) {
      Swal.fire({
        title: "Do you want to close this project?",
        showCancelButton: true,
        confirmButtonText: "Close",
        cancelButtonText: "Don't Close",
        text:
          "Caution!! When you close a section, you can not reopen to get more stars",
      }).then((res) => {
        if (res.isConfirmed) {
          axios
            .put("/instances/" + i._id, {
              $set: { dateFinished: new Date() },
            })
            .then((response) => {
              console.log(response);
              this.$store.dispatch("fetchMyInstances");
              if (response.status == 200) {
                Swal.fire({
                  title: "Project Closed",
                  text: "",
                  icon: "success",
                });
              }
            });
        }
      });
    },
  },
  computed: {
    myInstances() {
      return this.$store.getters.getMyInstances;
    },
    myTeam() {
      return this.$store.getters.getMyTeam;
    },
    project() {
      return this.$store.getters.getProjects.find(
        (p) => p._id == this.$route.params.projectId
      );
    },
    sections() {
      return this.$store.getters.getProjects.filter((p) =>
        this.project.sections.includes(p._id)
      );
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    currentUser() {
      return this.$store.getters.getMyUser;
    },
    ...mapGetters(["breadcrumbs", "pageTitle", "layoutConfig"]),
  },
};
</script>
<style lang="scss" scoped>
.d-grid {
  display: grid;
  grid-template-columns: repeat(1, 50px 1fr 60px) 150px !important;
}
.tag-dev {
  background-color: #fff4df;
}

.tag-dis {
  background-color: #e1f0ff;
}

.info-singel-project {
  border-radius: 6px;
  padding: 11px;
}

i {
  color: #0bb7af;
}

.bg-succes {
  background-color: #0bb7af;
}

img.ranking {
  margin-right: 10px;
}

.symbol.symbol-light-info .symbol-label.bg-design {
  background-color: #0bb7af;
}

.symbol.symbol-light-info .symbol-label.bg-js {
  background-color: rgba(246, 78, 96, 0.5);
}

.item-grafica-projecte {
  margin-bottom: 20px;
}

.apexcharts-legend {
  display: none !important;
}

p ul {
  padding-left: 30px;
}

p img {
  width: 100%;
  margin: 10px 0;
}
.image {
  height: 400px;
  background-size: cover;
  margin-bottom: 20px;
}
</style>
